import { getDeviceType } from "utils";
import { rootStore } from "@store/rootStore";

const HEADER_OS_DEVICE_TYPE = "OS-Device-Type" as const;
const HEADER_OS_DEVICE_ID = "OS-Device-Id" as const;

/**
 * 给 `/auth/login` 补设备头（与 `features/api/client/factories` 各 Index 客户端同值）：
 * - `OS-Device-Type`：ANDROID / IOS（App 壳内 WebView）| PC（纯浏览器）。opensocial 据此给
 *   注册/登录事件与 trackMeta 写 platform —— 缺了它 platform 为 null，kevent 只能靠有无 idfa
 *   猜平台，iOS 拒绝 ATT 的用户会被当成 Android 上报 Adjust。
 * - `OS-Device-Id`：设备指纹（`initFingerprint` 写入），未就绪不带。
 */
export function mergeDeviceHeaders(
  headers: Record<string, string>,
): Record<string, string> {
  const out: Record<string, string> = {
    ...headers,
    [HEADER_OS_DEVICE_TYPE]: (getDeviceType() ?? "unknown").toUpperCase(),
  };
  const fingerprint = rootStore.user.fingerprint;
  if (fingerprint) {
    out[HEADER_OS_DEVICE_ID] = fingerprint;
  }
  return out;
}
